import { cn } from "@/lib/utils";

type Status = "new" | "in_review" | "completed" | "claimed" | "claim_approved" | "claim_rejected";

interface StatusPillProps {
  status: Status;
  className?: string;
}

const statusConfig: Record<Status, { label: string; className: string }> = {
  new: {
    label: "Neu",
    className: "bg-accent/10 text-accent border-accent/20",
  },
  in_review: {
    label: "Angenommen",
    className: "bg-primary/10 text-primary border-primary/20",
  },
  completed: {
    label: "Abgeschlossen",
    className: "bg-muted text-muted-foreground border-border",
  },
  claimed: {
    label: "Reklamiert",
    className: "bg-destructive/10 text-destructive border-destructive/20",
  },
  claim_approved: {
    label: "Reklamation genehmigt",
    className: "bg-accent/10 text-accent border-accent/20",
  },
  claim_rejected: {
    label: "Reklamation abgelehnt",
    className: "bg-muted text-muted-foreground border-border",
  },
};

export const StatusPill = ({ status, className }: StatusPillProps) => {
  const config = statusConfig[status];
  
  return (
    <span
      className={cn(
        "inline-flex items-center px-3 py-1 text-xs font-medium border rounded-sm tracking-wide",
        config.className,
        className
      )}
    >
      {status === "new" && (
        <span className="w-1.5 h-1.5 bg-accent rounded-full mr-2 animate-pulse" />
      )}
      {config.label}
    </span>
  );
};
